import MustahanButton from '../MustahanButton';

export default MustahanButton;
